/**
 * Kaptana ait bölüm (ADR 0127): arıza LGS-17 Part B ve HSEQ "Master's Initial Assessment" yalnız
 * kaptan ya da (kaptan ataması yokken) şirketin seçtiği vekil yazar; yazan ve rütbesi kayıtta
 * görünür. Ayarlar ▸ Kaptanın vekili.
 */
export const masterSectionEn = {
  locked:
    'Only the Master writes this section (ISM Code 5). When no Master is assigned to the vessel, the deputy set in Settings writes it on behalf of the Master.',
  deputy: 'No Master is assigned: you write this section on behalf of the Master.',
  writtenBy: 'Written by {{name}} ({{rank}}) · {{at}}',
  onBehalf: 'On behalf of Master',
  noRank: 'no rank on board',
  partBFirst:
    'Part B must be filled by the Master first (Action taken by captain). The defect can be submitted for closure after that.',
  errors: {
    MASTER_ONLY:
      'Only the Master (or the Master’s deputy when no Master is assigned) can do this (ISM Code 5).',
  },
  settings: {
    title: 'Master’s deputy',
    text: 'Sections that belong to the Master (defect Part B, the Master’s initial assessment of an HSEQ report, rejecting a repair) are written only by the Master. Choose a rank that may write them on behalf of the Master while no Master is assigned to the vessel. The record shows “On behalf of Master”.',
    role: 'Deputy rank',
    none: 'None — only the Master',
    save: 'Save',
    saved: 'Saved. Vessels receive the setting with the next synchronisation.',
    error: 'The setting could not be saved.',
    retry: 'Try again',
  },
};

export const masterSectionTr: typeof masterSectionEn = {
  locked:
    'Bu bölümü yalnız kaptan yazar (ISM Kod 5). Gemide kaptan ataması yokken Ayarlar’da seçilen vekil kaptan adına yazar.',
  deputy: 'Gemide kaptan ataması yok: bu bölümü kaptan adına yazıyorsunuz.',
  writtenBy: 'Yazan: {{name}} ({{rank}}) · {{at}}',
  onBehalf: 'Kaptan adına',
  noRank: 'gemide rütbesi yok',
  partBFirst:
    'Önce kaptan Bölüm B’yi doldurmalı (kaptanın aldığı önlem). Arıza ondan sonra kapanışa gönderilir.',
  errors: {
    MASTER_ONLY:
      'Bunu yalnız kaptan (kaptan ataması yokken kaptanın vekili) yapabilir (ISM Kod 5).',
  },
  settings: {
    title: 'Kaptanın vekili',
    text: 'Kaptana ait bölümleri (arıza Bölüm B, HSEQ raporunda kaptanın ilk değerlendirmesi, onarımın reddi) yalnız kaptan yazar. Gemide kaptan ataması yokken bunları kaptan adına yazabilecek rütbeyi seçin. Kayıtta “Kaptan adına” görünür.',
    role: 'Vekil rütbe',
    none: 'Yok — yalnız kaptan',
    save: 'Kaydet',
    saved: 'Kaydedildi. Gemiler ayarı sonraki senkronla alır.',
    error: 'Ayar kaydedilemedi.',
    retry: 'Yeniden dene',
  },
};
